import colors from "assets/css/colors";

export default function option(styles, { isSelected, isFocused, isDisabled }) {
  const backgroundColor = isDisabled
    ? colors.lightGrey
    : (isSelected || isFocused) && colors.lightBlue;

  return {
    ...styles,
    color: colors.mainBlack,
    boxSizing: "border-box",
    height: 41,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    borderBottomLeftRadius: "inherit",
    borderBottomRightRadius: "inherit",
    backgroundColor,
    "&:not(:first-of-type)": {
      borderTop: `1px solid ${colors.strokeGrey}`,
    },
    "&:hover, &:focus, &:active": {
      backgroundColor: colors.lightBlue,
    },
  };
}
